import {notice} from "./UI/notice";

export const  changeInputFile = input => {
    if (input.files && input.files[0]) {
        let file = input.files[0];

        if (!file.type.match('image/*|application/pdf|application/vnd.openxmlformats-officedocument.wordprocessingml.document|text/csv')) {
            notice('Формат файла не прошел проверку');
            input.value = "";
            return;
        }

        let js_form_file = input.closest('.js_form_file');
        if (js_form_file) {
            let js_form_file_list = js_form_file.querySelector('.js_form_file_list');
            if (js_form_file_list) {
                js_form_file_list.innerHTML = `<div class=" d-flex align-items-center gap-5 mb-sm-20 mb-10">
                            <i class="icon u_paperclip"></i><span class="fs-14">${file.name}</span><i class="Close icon text-main js_form_remove_file pointer"></i>
                        </div>`;
                let js_form_remove_file = js_form_file_list.querySelector('.js_form_remove_file');
                if (js_form_remove_file) {
                    js_form_remove_file.addEventListener('click', () => {
                        js_form_file_list.innerHTML = "";
                        input.value = "";
                    });
                }
            }
        }
    }
};